/**
 * fetch 자체가 실패한 네트워크 오류인지 판별한다 (mfms `lib/query-client` isNetworkError 이식).
 *
 * 화면의 조회 실패 안내를 "인터넷 연결" / "서버 오류" 문구로 나눌 때 쓴다.
 * 'Failed to fetch': Chrome/Firefox, 'Load failed': Safari, 'NetworkError...': Firefox (일부)
 */
export function isNetworkError(error: Error): boolean {
  if (error.name !== 'TypeError') {
    return false;
  }
  const msg = error.message;
  return (
    msg === 'Failed to fetch' ||
    msg === 'Load failed' ||
    msg === 'NetworkError when attempting to fetch resource.'
  );
}
